import React from 'react';
import { Box, Flex } from 'rebass';
import { useLocation } from 'react-router-dom';

import { ModalCloseButton, SmallDivider } from '@mdlinx/component-library';
import { Auth } from '@mdlinx/shared';

import { postAuthIframeMessage } from 'app/utils/post-auth-iframe-message';
import { alternativeSceneLink } from './alternative-scene-link';

export type ContainerProps = {
  children: React.ReactNode;
  withCloseButton?: boolean;
  alternativeScene?: 'sign-up' | 'login';
  onLoginLinkClicked: () => void;
  onSignUpLinkClicked: () => void;
};

export const ModalContainer = ({
  children,
  withCloseButton,
  alternativeScene,
  onLoginLinkClicked,
  onSignUpLinkClicked,
}: ContainerProps) => {
  const location = useLocation();
  const onCloseButtonClick = () => {
    postAuthIframeMessage({ message: Auth.abortLogin, pathname: location.pathname, search: location.search });
  };

  const alternativeSceneElement = alternativeSceneLink({
    alternativeScene,
    onLoginLinkClicked,
    onSignUpLinkClicked,
  });

  return (
    <Box pt="20px" pb="20px" px="8px">
      {withCloseButton ? <ModalCloseButton onClose={onCloseButtonClick} modalIsDismissable={withCloseButton} /> : null}

      {alternativeSceneElement ? (
        <>
          <Flex justifyContent="center">{alternativeSceneElement}</Flex>
          <Flex justifyContent="center">
            <SmallDivider />
          </Flex>
        </>
      ) : null}

      <Box width="100%" backgroundColor="#fff" px="12px">
        <Box mx="auto">{children}</Box>
      </Box>
    </Box>
  );
};
